module.exports = __webpack_public_path__ + "img/yq3.7ba615a1.png";